<!-- 图片列表卡片 -->
<template>
  <div class="group relative h-full w-full cursor-pointer" :style="cardBg" @click="openDialog()">
    <div
      class="absolute bottom-0 left-0 right-0 top-0 flex flex-col bg-[rgba(0,0,0,.4)] px-[10px] opacity-0 transition-all group-hover:opacity-100"
    >
      <div class="flex-1"></div>
      <el-divider class="!mb-[6px]" style="background-color: #fff !important;"></el-divider>
      <p class="mb-[20px] text-[14px] font-bold" style="color: #fff;">{{ detail.title }}</p>
      <p class="mb-[20px] flex items-center text-[14px]" style="color: #fff;">
        作者：{{ detail.author }}
        <el-divider direction="vertical" style="background-color: #fff !important;"></el-divider>
        {{ detail.create_time }}
      </p>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventbus';

export default {
  name: 'ListImgCard',
  props:{
    detail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    cardBg() {
      return `background:url("${this.detail.pic}") no-repeat center / cover;`;
    },
  },
  methods: {
    openDialog() {
      EventBus.$emit('dialogImageVisible', true, this.detail);
    },
  },
};
</script>

<style lang="scss" scoped></style>
